var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.349 13.7455V25.6326C4.349 26.3331 4.62731 27.005 5.1227 27.5004C5.61809 27.9958 6.28998 28.2741 6.99057 28.2741H25.4816C26.1821 28.2741 26.854 27.9958 27.3494 27.5004C27.8448 27.005 28.1231 26.3331 28.1231 25.6326V13.7455",
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9779 28.2741V20.3494C19.9779 19.6488 19.6996 18.9769 19.2042 18.4815C18.7088 17.9862 18.0369 17.7079 17.3363 17.7079H14.6947C13.9941 17.7079 13.3222 17.9862 12.8269 18.4815C12.3315 18.9769 12.0532 19.6488 12.0532 20.3494V28.2741",
    stroke: "#383E42",
    strokeWidth: 1.5,
    strokeMiterlimit: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2035 12.9055L26.9661 5.07454C26.9188 4.90898 26.8188 4.76335 26.6813 4.65968C26.5438 4.55602 26.3762 4.49996 26.204 4.5H20.8588L21.4862 12.0338C21.4959 12.1548 21.5342 12.2719 21.5981 12.3752C21.6619 12.4786 21.7494 12.5653 21.8534 12.6281C22.3685 12.9359 23.3749 13.5038 24.1608 13.7455C25.5027 14.1589 27.4628 14.0097 28.5801 13.8723C28.6888 13.8582 28.793 13.8207 28.8856 13.7622C28.9782 13.7037 29.057 13.6257 29.1163 13.5336C29.1757 13.4416 29.2142 13.3377 29.2293 13.2292C29.2444 13.1207 29.2356 13.0102 29.2035 12.9055Z",
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8777 13.7455C19.6279 13.5144 20.5789 12.9874 21.1098 12.673C21.2334 12.5991 21.3336 12.4919 21.399 12.3636C21.4644 12.2354 21.4924 12.0913 21.4796 11.9479L20.8589 4.5H11.6134L10.9926 11.9479C10.9796 12.0915 11.0075 12.2359 11.0729 12.3644C11.1383 12.4929 11.2387 12.6003 11.3624 12.6743C11.8934 12.9874 12.8444 13.5144 13.5946 13.7455C15.5665 14.3531 16.9058 14.3531 18.8777 13.7455Z",
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50607 5.07454L3.26866 12.9068C3.23707 13.0114 3.22863 13.1216 3.24391 13.2297C3.2592 13.3379 3.29784 13.4415 3.35715 13.5332C3.41647 13.6249 3.49504 13.7027 3.58741 13.761C3.67978 13.8193 3.78374 13.8569 3.89207 13.871C5.00813 14.0097 6.9695 14.1576 8.31141 13.7455C9.09728 13.5038 10.105 12.9359 10.6188 12.6294C10.7229 12.5664 10.8105 12.4796 10.8744 12.376C10.9383 12.2724 10.9765 12.1551 10.986 12.0338L11.6134 4.5H6.26816C6.09596 4.49996 5.92843 4.55602 5.79092 4.65968C5.65342 4.76335 5.55342 4.90898 5.50607 5.07454Z",
    stroke: "#383E42",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirShop);
export default __webpack_public_path__ + "static/media/iconoir_shop.62ec1d4b208a138739fd98cf9dadfee4.svg";
export { ForwardRef as ReactComponent };